import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { CmsService, GlobalMessageService, GlobalMessageType, Page, RoutingService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription, iif, of } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class NotFoundComponent implements OnInit, OnDestroy {
  background$: Observable<any[]> = this.componentData.data$;
  backendURL: string = null;
  desktopURL: string = null;
  mobileURL: string = null;
  tabletURL: string = null;
  deviceInfo: any = null;
  public innerHeight: any;
  public innerWidth: any;
  globalMsg = document.querySelector('cx-global-message');
  backgroundHandler: Subscription;

  constructor(
    public componentData: CmsComponentData<any>,
    private meta: Meta,
    private deviceService: DeviceDetectorService,
    private globalMessageService: GlobalMessageService,
    private elRef: ElementRef,
    private cmsService: CmsService,
    private routingService: RoutingService
  ) {
    this.globalMsg.removeAttribute('style');
    this.globalMsg.setAttribute('id', 'hideCxGlobalMessage');
  }

  ngOnInit() {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
    const occURL = this.meta.getTag('name=occ-backend-base-url');
    this.backendURL = occURL.content;
    this.innerHeight = window.innerHeight;
    this.innerWidth = window.innerWidth;
    const isTablet = this.deviceService.isTablet();
    this.backgroundHandler = this.cmsService
      .getCurrentPage()
      .pipe(
        filter(Boolean),
        switchMap((currentPage: Page) => iif(() => currentPage.label === '/not-found', this.background$, of(null)))
      )
      .subscribe((data) => {
        if (data && typeof data !== 'undefined') {
          Object.keys(data).forEach((key: any) => {
            if (key === 'media') {
              Object.keys(data[key]).forEach((deviceType) => {
                Object.keys(data[key][deviceType]).forEach((url) => {
                  if (url === 'url') {
                    if (deviceType === 'mobile') {
                      this.mobileURL = data[key][deviceType][url];
                    } else if (deviceType === 'tablet') {
                      this.tabletURL = data[key][deviceType][url];
                    } else {
                      this.desktopURL = data[key][deviceType][url];
                    }
                  }
                });
              });
            }
          });

          if (this.innerWidth < 577) {
            if (this.innerHeight >= 740) {
              if (isTablet) {
                this.backendURL += this.tabletURL;
              } else {
                this.backendURL += this.mobileURL;
              }
            } else {
              this.backendURL += this.mobileURL;
            }
          } else if (this.innerWidth < 768) {
            this.backendURL += this.tabletURL;
          } else {
            if (isTablet) {
              this.backendURL += this.tabletURL;
            } else {
              this.backendURL += this.desktopURL;
            }
          }

          if (!this.elRef.nativeElement.parentElement.parentElement.hasAttribute('style')) {
            this.elRef.nativeElement.parentElement.parentElement.style.backgroundImage =
              'url("' + this.backendURL + '")';
          }
        } else {
          this.elRef.nativeElement.parentElement.parentElement.removeAttribute('style');
        }
      });
    this.cmsService
      .getCurrentPage()
      .pipe(take(1))
      .subscribe((data) => {
        if (data.label === '/not-found') {
          this.routingService.goByUrl('/not-found');
        }
      });
  }

  ngOnDestroy() {
    if (this.backgroundHandler) {
      this.backgroundHandler.unsubscribe();
    }
    this.globalMsg.removeAttribute('id');
  }
}
